import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./index.css";
import MegaBannerImage1 from "../../../assets/images/MegaBannerImage1.jpg";
import MegaBannerImage2 from "../../../assets/images/MegaBannerImage2.jpg";
import MegaBannerImage3 from "../../../assets/images/MegaBannerImage3.jpg";
import MegaBannerImage4 from "../../../assets/images/MegaBannerImage4.jpg";
import MegaBannerImage5 from "../../../assets/images/MegaBannerImage5.jpg";

const CategoriesBar = ({ t }) => {
  const [showSubcat, setShowSubcat] = useState(false);
  const [categories, setCategories] = useState([]);
  const [activeDropdown, setActiveDropdown] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get("/allcategories")
      .then(function (response) {
        console.log(response.data);
        const respData = response.data;
        respData.reverse();
        setCategories(respData);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, []);

  const goToCategoryDetails = (ev, categoryId) => {
    ev.preventDefault();
    navigate("/categoryDetails/" + categoryId);
  };

  const handleDropdownToggle = (dropdownName) => {
    setActiveDropdown(activeDropdown === dropdownName ? null : dropdownName);
  };

  const styles = {
    categoriesBar: {
      backgroundColor: '#2c3e50',
      boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
      position: 'relative',
      zIndex: 99,
    },
    container: {
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '0 20px',
    },
    catsBar: {
      display: 'flex',
      alignItems: 'center',
      minHeight: '60px',
    },
    cats: {
      position: 'relative',
      backgroundColor: '#34495e',
      color: 'white',
      padding: '15px 25px',
      cursor: 'pointer',
      borderRadius: '8px 8px 0 0',
      marginRight: '20px',
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
      fontWeight: '600',
      fontSize: '16px',
      transition: 'all 0.3s ease',
      minWidth: '200px',
      justifyContent: 'center',
    },
    catsHover: {
      backgroundColor: '#3498db',
      transform: 'translateY(-2px)',
    },
    catsIcon: {
      fontSize: '18px',
    },
    subCats: {
      position: 'absolute',
      top: '100%',
      left: '0',
      backgroundColor: 'white',
      minWidth: '250px',
      borderRadius: '0 8px 8px 8px',
      boxShadow: '0 8px 25px rgba(0,0,0,0.15)',
      overflow: 'hidden',
      zIndex: 1001,
    },
    subCatsList: {
      listStyle: 'none',
      margin: '0',
      padding: '0',
    },
    subCatItem: {
      position: 'relative',
      borderBottom: '1px solid #ecf0f1',
    },
    subCatLink: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '15px 20px',
      color: '#2c3e50',
      textDecoration: 'none',
      transition: 'all 0.3s ease',
      fontWeight: '500',
    },
    subCatLinkHover: {
      backgroundColor: '#f8f9fa',
      color: '#3498db',
      paddingLeft: '25px',
    },
    chevronIcon: {
      fontSize: '12px',
      color: '#bdc3c7',
    },
    otherCats: {
      display: 'flex',
      alignItems: 'center',
      gap: '30px',
      flex: 1,
    },
    otherCat: {
      position: 'relative',
      color: 'white',
      padding: '15px 20px',
      cursor: 'pointer',
      borderRadius: '6px',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      fontWeight: '500',
      fontSize: '15px',
      transition: 'all 0.3s ease',
    },
    otherCatHover: {
      backgroundColor: 'rgba(255,255,255,0.1)',
      transform: 'translateY(-1px)',
    },
    megaSubCat: {
      position: 'absolute',
      top: '100%',
      left: '50%',
      transform: 'translateX(-50%)',
      backgroundColor: 'white',
      borderRadius: '12px',
      boxShadow: '0 15px 35px rgba(0,0,0,0.1)',
      padding: '30px',
      minWidth: '800px',
      zIndex: 1001,
      marginTop: '10px',
    },
    megaSubCatLeft: {
      left: '0',
      transform: 'none',
    },
    megaRow: {
      display: 'flex',
      gap: '20px',
      marginBottom: '25px',
    },
    megaCol: {
      flex: '1',
    },
    megaImage: {
      width: '100%',
      height: '150px',
      objectFit: 'cover',
      borderRadius: '8px',
      transition: 'transform 0.3s ease',
    },
    megaImageHover: {
      transform: 'scale(1.05)',
    },
    megaTitle: {
      color: '#2c3e50',
      fontSize: '16px',
      fontWeight: '600',
      marginBottom: '8px',
      cursor: 'pointer',
      transition: 'color 0.3s ease',
    },
    megaTitleHover: {
      color: '#3498db',
    },
    divider: {
      border: 'none',
      height: '1px',
      backgroundColor: '#ecf0f1',
      margin: '25px 0',
    },
    categoryItem: {
      color: '#2c3e50',
      fontSize: '15px',
      fontWeight: '500',
      marginBottom: '10px',
      cursor: 'pointer',
      padding: '8px 12px',
      borderRadius: '6px',
      transition: 'all 0.3s ease',
    },
    categoryItemHover: {
      backgroundColor: '#f8f9fa',
      color: '#3498db',
      transform: 'translateX(5px)',
    },
    fullWidthImage: {
      width: '100%',
      height: '200px',
      objectFit: 'cover',
      borderRadius: '8px',
    },
  };

  return (
    <div className="categories-bar">
      <div style={styles.container}>
        <div style={styles.catsBar}>
          <div
            style={{
              ...styles.cats,
              ...(showSubcat ? styles.catsHover : {}),
            }}
            onClick={() => setShowSubcat(!showSubcat)}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#3498db';
              e.target.style.transform = 'translateY(-2px)';
            }}
            onMouseLeave={(e) => {
              if (!showSubcat) {
                e.target.style.backgroundColor = '#34495e';
                e.target.style.transform = 'translateY(0)';
              }
            }}
          >
            <i className="fa fa-bars" style={styles.catsIcon}></i>
            {t("Categories")}
            {showSubcat && (
              <div style={{ ...styles.subCats, ...styles.megaSubCatLeft }}>
                <ul style={styles.subCatsList}>
                  <li style={styles.subCatItem}>
                    <Link
                      to={"/categoryDetails/2"}
                      style={styles.subCatLink}
                      onMouseEnter={(e) => {
                        e.target.style.backgroundColor = '#f8f9fa';
                        e.target.style.color = '#3498db';
                        e.target.style.paddingLeft = '25px';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.backgroundColor = 'transparent';
                        e.target.style.color = '#2c3e50';
                        e.target.style.paddingLeft = '20px';
                      }}
                    >
                      {t("hotDeals")}
                      <i className="fa fa-chevron-right" style={styles.chevronIcon}></i>
                    </Link>
                  </li>

                  <li style={styles.subCatItem}>
                    <Link
                      to={"/categoryDetails/4"}
                      style={styles.subCatLink}
                      onMouseEnter={(e) => {
                        e.target.style.backgroundColor = '#f8f9fa';
                        e.target.style.color = '#3498db';
                        e.target.style.paddingLeft = '25px';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.backgroundColor = 'transparent';
                        e.target.style.color = '#2c3e50';
                        e.target.style.paddingLeft = '20px';
                      }}
                    >
                      {t("elComp")}
                      <i className="fa fa-chevron-right" style={styles.chevronIcon}></i>
                    </Link>
                  </li>

                  {categories.length &&
                    categories.map((item, index) => (
                      <li key={index} style={styles.subCatItem}>
                        <Link
                          to={"/categoryDetails/" + item.slug}
                          style={styles.subCatLink}
                          onMouseEnter={(e) => {
                            e.target.style.backgroundColor = '#f8f9fa';
                            e.target.style.color = '#3498db';
                            e.target.style.paddingLeft = '25px';
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.backgroundColor = 'transparent';
                            e.target.style.color = '#2c3e50';
                            e.target.style.paddingLeft = '20px';
                          }}
                        >
                          {item.name}
                        </Link>
                      </li>
                    ))}
                </ul>
              </div>
            )}
          </div>

          <div style={styles.otherCats}>
            <div
              style={{
                ...styles.otherCat,
                ...(activeDropdown === 'collect' ? styles.otherCatHover : {}),
              }}
              onClick={() => handleDropdownToggle('collect')}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = 'rgba(255,255,255,0.1)';
                e.target.style.transform = 'translateY(-1px)';
              }}
              onMouseLeave={(e) => {
                if (activeDropdown !== 'collect') {
                  e.target.style.backgroundColor = 'transparent';
                  e.target.style.transform = 'translateY(0)';
                }
              }}
            >
              {t("collect")}
              <i className="fa fa-chevron-down"></i>
              {activeDropdown === 'collect' && (
                <div style={styles.megaSubCat}>
                  <div style={styles.megaRow}>
                    {[MegaBannerImage1, MegaBannerImage2, MegaBannerImage3, MegaBannerImage4].map((img, index) => (
                      <div key={index} style={styles.megaCol}>
                        <img
                          style={styles.megaImage}
                          src={img}
                          alt=""
                          onMouseEnter={(e) => {
                            e.target.style.transform = 'scale(1.05)';
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.transform = 'scale(1)';
                          }}
                        />
                      </div>
                    ))}
                  </div>
                  <hr style={styles.divider} />
                  <div style={styles.megaRow}>
                    <div style={styles.megaCol}>
                      <h6 style={styles.megaTitle}>{t("cam")}</h6>
                    </div>
                    <div style={styles.megaCol}>
                      <h6 style={styles.megaTitle}>{t("comp")}</h6>
                      <h6 style={styles.megaTitle}>{t("mice")}</h6>
                      <h6 style={styles.megaTitle}>{t("mon")}</h6>
                      <h6 style={styles.megaTitle}>{t("print")}</h6>
                      <h6 style={styles.megaTitle}>{t("scann")}</h6>
                      <h6 style={styles.megaTitle}>{t("webcam")}</h6>
                    </div>
                    <div style={styles.megaCol}>
                      <h6 style={styles.megaTitle}>{t("tabs")}</h6>
                    </div>
                    <div style={styles.megaCol}>
                      <h6 style={styles.megaTitle}>{t("desk")}</h6>
                      <h6 style={styles.megaTitle}>{t("pc")}</h6>
                      <h6 style={styles.megaTitle}>{t("mc")}</h6>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div
              style={{
                ...styles.otherCat,
                ...(activeDropdown === 'newArrivals' ? styles.otherCatHover : {}),
              }}
              onClick={() => handleDropdownToggle('newArrivals')}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = 'rgba(255,255,255,0.1)';
                e.target.style.transform = 'translateY(-1px)';
              }}
              onMouseLeave={(e) => {
                if (activeDropdown !== 'newArrivals') {
                  e.target.style.backgroundColor = 'transparent';
                  e.target.style.transform = 'translateY(0)';
                }
              }}
            >
              {t("NewArrivals")}
              <i className="fa fa-chevron-down"></i>
              {activeDropdown === 'newArrivals' && (
                <div style={styles.megaSubCat}>
                  <div style={styles.megaRow}>
                    <div style={styles.megaCol}>
                      {categories.length &&
                        categories.map((item, index) => (
                          <h6
                            key={index}
                            style={styles.categoryItem}
                            onClick={(ev) => goToCategoryDetails(ev, item.slug)}
                            onMouseEnter={(e) => {
                              e.target.style.backgroundColor = '#f8f9fa';
                              e.target.style.color = '#3498db';
                              e.target.style.transform = 'translateX(5px)';
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.backgroundColor = 'transparent';
                              e.target.style.color = '#2c3e50';
                              e.target.style.transform = 'translateX(0)';
                            }}
                          >
                            {item.name}
                          </h6>
                        ))}
                    </div>
                    <div style={styles.megaCol}></div>
                  </div>
                  <hr style={styles.divider} />
                  <div style={styles.megaRow}>
                    <div style={{ ...styles.megaCol, flex: '1' }}>
                      <img
                        style={styles.fullWidthImage}
                        src={MegaBannerImage5}
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div
              style={{
                ...styles.otherCat,
                ...(activeDropdown === 'pages' ? styles.otherCatHover : {}),
              }}
              onClick={() => handleDropdownToggle('pages')}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = 'rgba(255,255,255,0.1)';
                e.target.style.transform = 'translateY(-1px)';
              }}
              onMouseLeave={(e) => {
                if (activeDropdown !== 'pages') {
                  e.target.style.backgroundColor = 'transparent';
                  e.target.style.transform = 'translateY(0)';
                }
              }}
            >
              {t("pages")}
              <i className="fa fa-chevron-down"></i>
            </div>

            <div
              style={styles.otherCat}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = 'rgba(255,255,255,0.1)';
                e.target.style.transform = 'translateY(-1px)';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = 'transparent';
                e.target.style.transform = 'translateY(0)';
              }}
            >
              {t("hots")}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CategoriesBar;